import { render, staticRenderFns } from "./player-mascot-registration-success.vue?vue&type=template&id=ea6065b2&scoped=true&lang=pug"
import script from "./player-mascot-registration-success.vue?vue&type=script&setup=true&lang=js"
export * from "./player-mascot-registration-success.vue?vue&type=script&setup=true&lang=js"
import style0 from "./player-mascot-registration-success.vue?vue&type=style&index=0&id=ea6065b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6065b2",
  null
  
)

export default component.exports